export const sceneGuidesState = $state({ grid: false, legend: false });
